import React from "react";

const FemaleAvatarIcon = ({
  size = 32,
  backgroundColor = "#D2C3B1",
  color = "#3C2212",
  strokeWidth = 2,
  className = "",
  ...props
}) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      {...props}
    >
      <rect
        width="32"
        height="32"
        rx="16"
        fill={backgroundColor}
      />

      <mask
        id="avatar-mask"
        style={{ maskType: "luminance" }}
        maskUnits="userSpaceOnUse"
        x="6"
        y="6"
        width="20"
        height="20"
      >
        <path
          d="M6.3999 6.4001H25.5999V25.6001H6.3999V6.4001Z"
          fill="white"
        />
      </mask>

      <g mask="url(#avatar-mask)">
        <path
          d="M9.79509 22.043C7.23692 20.9242 9.81241 19.6238 9.81241 18.5394C9.81241 17.5547 8.68742 17.695 8.68742 16.57C8.68742 15.445 9.81241 14.8748 9.81241 13.1873C9.81241 9.77001 12.5827 6.96227 15.9999 6.96227C19.4172 6.96227 22.1874 9.77001 22.1874 13.1873C22.1874 14.8748 23.3124 15.445 23.3124 16.57C23.3124 17.695 22.1874 17.5547 22.1874 18.5394C22.1874 19.6238 24.7629 20.9242 22.2047 22.043"
          stroke={color}
          strokeWidth={strokeWidth}
          strokeMiterlimit="10"
        />

        <path
          d="M17.6873 18.9966V20.5005"
          stroke={color}
          strokeWidth={strokeWidth}
          strokeMiterlimit="10"
        />

        <path
          d="M14.3123 20.5005V18.9966"
          stroke={color}
          strokeWidth={strokeWidth}
          strokeMiterlimit="10"
        />

        <path
          d="M15.9998 19.3755C13.8251 19.3755 12.0623 17.6126 12.0623 15.438V13.5005C12.0623 12.3959 12.9577 11.5005 14.0623 11.5005H17.9373C19.0418 11.5005 19.9373 12.3959 19.9373 13.5005V15.438C19.9373 17.6126 18.1744 19.3755 15.9998 19.3755Z"
          stroke={color}
          strokeWidth={strokeWidth}
          strokeMiterlimit="10"
        />

        <path
          d="M18.2498 19.7003C17.9391 19.7003 17.6873 19.9521 17.6873 20.2628C17.6873 21.1948 16.9317 21.9503 15.9998 21.9503C15.0678 21.9503 14.3123 21.1948 14.3123 20.2628C14.3123 19.9521 14.0604 19.7003 13.7498 19.7003H13.1873C11.1116 19.7003 9.3642 21.1318 8.84455 23.0514C8.67138 23.6911 9.22451 24.2378 9.88726 24.2378H22.1123C22.775 24.2378 23.3281 23.6911 23.155 23.0514C22.6353 21.1318 20.8879 19.7003 18.8123 19.7003H18.2498Z"
          stroke={color}
          strokeWidth={strokeWidth}
          strokeMiterlimit="10"
        />
      </g>
    </svg>
  );
};

export default FemaleAvatarIcon;